import { Typography } from '@mui/material';
import styled, { css } from 'styled-components';

export const PanelRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

export const Caption = styled.span(
  ({ theme: { palette } }) => css`
    font-size: 12px;
    color: ${palette.info.main};
  `,
);

export const RowActions = styled.div`
  display: flex;
  gap: 6px;
`;

/** Heading of the queue table; the table itself sits on the page background like every other list. */
export const TableTitle = styled(Typography)`
  margin: 8px 0 12px;
`;
